import { createRouter, createWebHashHistory } from 'vue-router'
import { routes } from './routers'
import {parseUrl2Obj} from '../libs/util'

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({
		top: 0
	}),
  routes,
})

// const toWxLogin = (to, appId) => {
//   let href = window.location.origin + window.location.pathname + '#' + to.fullPath
//   sessionStorage.setItem('oldUrl', href)
//   sessionStorage.setItem('oldName', to.name)
//   let authUrl = `${window.location.origin}${window.location.pathname}#/wxlogin`
//   let callBackUrl = encodeURIComponent(authUrl)
//   let authorizeUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${callBackUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
//   window.location.replace(authorizeUrl)
// }

router.beforeEach((to, from, next) => {
  // sessionStorage.setItem('token', 'feahvJWLZP88FddSbhv_1NMdddPJMEvXvNiUDCKxLIpMVgOpXvrqGjDhgs1mxKFP')
  // sessionStorage.setItem('token', 'nvBveuu4dM2BnBhJ5Ku-WnOtwVrXUmRgcwWZ3IxFY5S7wG9EBWznq5nv_8EleCT5WL7-5bOy9esYgglfjlD--0xWA6le_uoaMOGCzWbEoU8/')
  // sessionStorage.setItem('token', 'nvBveuu4dM2BnBhJ5Ku-WnOtwVrXUmRgcwWZ3IxFY5S7wG9EBWznq5nv_8EleCT5WL7-5bOy9esYgglfjlD--0xWA6le_uoaMOGCzWbEoU8/')
  to.meta.title ? document.title = to.meta.title : '新东方'
  
  console.log('路由是什么', to.name)
  // appId = GAPPID
  if (to.name === 'wxlogin' || to.name === 'otherRouter') {
    console.log('授权页面')
    next()
  } else {
    //  获取链接参数url
    let {
          productId,
    } = parseUrl2Obj(window.location.href) // 获取url拼接的参数
  
    // 下一步 可做判断
    next()
  }
})

router.afterEach(() => {
  // document.body.scrollTop = 0
  // document.getElementById('app').scrollTop = 0
})

export default router
